import { grey } from '@material-ui/core/colors';
export const primary = {
  light: '#d2ebe2',
  main: '#68bb93',
  dark: '#489671',
  contrastText: '#fff'
};
export const secondary = {
  light: '#B9DCD2',
  main: '#BAC5B9',
  dark: '#708866',
  contrastText: '#fff'
};
export const success = {
  light: '#92D982',
  main: '#89CD7A',
  dark: '#708866',
  contrastText: '#fff'
};
export const error = {
  light: '#DC7C86',
  main: '#C00D1E',
  dark: '#8C0A17',
  contrastText: '#fff'
};
export const warning = {
  light: '#FAE5A0',
  main: '#ECD898',
  dark: '#B89F58',
  contrastText: '#fff'
};
export const info = {
  light: '#B1C7E3',
  main: '#A7BCD6',
  dark: '#444C57',
  contrastText: '#fff'
};
export const text = {
  primary: '#333',
  secondary: '#555',
  disabled: '#999',
  hint: '#CCC'
};
export const textExtra = {
  heading: '#555',
  contrast: '#777'
};
export const action = {
  disabledBackground: '#CCC'
};
export const commonColors = {
  white: '#FFF',
  black: '#000'
}; // TODO [@ori-ui/material-ui@2]: Replace backgrounds
// https://xd.adobe.com/view/9b8e9ecc-4b97-48e3-92c4-a7767757eec1-cedd/screen/9f99d67c-31fb-46bc-b466-28a7d4d0d385

export const background = {
  paper: commonColors.white,
  default: grey[50],
  chromeWhite: '#e1efce',
  chatelle: '#b3b0c4',
  wafer: '#e4d5d3',
  newOrleans: '#f0bf9b',
  softAmber: '#d7c4b7',
  snowFlurry: '#dcffbd',
  viking: '#6ed0de',
  danube: '#6b93d7',
  bouquet: '#b36faf',
  kobi: '#eea7c2',
  porsche: '#efae6e',
  kournikova: '#ffda78',
  sandal: '#b48f73',
  wedgewood: '#4c919c',
  kashmirBlue: '#4c6c9c',
  trendyPink: '#856c98',
  strikeMaster: '#98607c',
  santaFe: '#b57363',
  tussock: '#c7984f',
  sandDune: '#837165',
  greenSpring: '#b9c5b8',
  athensGray: '#eaeaf0',
  pinkFlare: '#dfc2c3'
};
export const oriGrey = {
  50: '#fafafa',
  100: '#f5f5f5',
  200: '#e5e5e5',
  300: '#cccccc',
  400: '#bbbbbb',
  500: '#888888',
  600: '#777777',
  700: '#555555',
  800: '#444444',
  900: '#333333',
  A100: '#f0f0f0',
  A200: '#dddddd',
  A400: '#999999',
  A700: '#666666',
  A900: '#2a2a2a'
};